//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.DisplayResolutionBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"AutomaticUpdate",1,0],[1,"DisplayResolution",0,"GeometricUtilities.DisplayResolutionBuilder",0],[1,"MaximumOverhangAngle",0,"Expression",0],[0,"NonOverheatingColor",1,0],[0,"OverheatingArea",0,0],[0,"OverheatingColor",1,0],[0,"SelectionAndPlacement",0,"Validate.SelectionAndPlacementBuilder",0],[0,"ShowOnlyOverheatingAreas",1,0]],[[[],"Update",{},0,0]],[]];
SPLM.Validate.CheckOverheatingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.CheckOverheatingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;